module.exports = __webpack_public_path__ + "src/img/mail.023c57fc.svg";